import genericFunctionalityRoutes from '@/overlay/GenericFunctionality/GenericFunctionality.routes.js'

const baseRoutes = genericFunctionalityRoutes

export default baseRoutes
